import axios from "axios";
import { getApiBaseUrl } from "../../../config";

const apiPrefix = getApiBaseUrl("auth");

export const getDashBoardData = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/get-dashboard-data`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getAssignedCategories = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/assigned-categories`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getCategoryPerClientGraph = async (token, formData) => {
  return await axios.post(`${apiPrefix}/api/v1/category-per-client`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getTopCategoryGraph = async (token, formData) => {
  return await axios.post(
    `${apiPrefix}/api/v1/top-selected-categories`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
};
